import { ComponentElem } from "@components/interfaces";
import PopupBase from "./PopupBase";
import Popups from "./Popups";

export type ValueSelectorResult = {
  value: any
  text: string
}

export default class ValueSelector extends PopupBase
{
  static instance: ValueSelector;

  constructor(elem: ComponentElem)
  {
    super(elem);

    ValueSelector.instance = this;
  }

  /**
   * 選項下拉選單
   * @param valueList 選項清單
   * @param targetelem 觸發元素位置 (null 時畫面置中顯示)
   * @param cb 
   * @returns 
   */
  show(valueList: string[] | { text: string, value: any }[], targetelem?: HTMLElement, setBackPopup?: string)
  {
    if (valueList.length === 0) return;

    return new Promise((resolve) =>
    {
      let $wrapper = this.$root.find(".wrapper");
      $wrapper.empty();

      valueList.forEach((obj: string | { text: string, value: any }, index) =>
      {
        let itemObj = typeof obj === "string" ? { text: obj, value: obj } : { text: obj.text, value: obj.value };

        let $item = $(`<div class="item">${itemObj.text}</div>`);
        $item.on("click", (event: Event) =>
        {
          event.preventDefault();

          targetelem ? Popups.closeMenu() : Popups.close();
          resolve(itemObj);
        });

        if (index > 0) $wrapper.append(`<div class="item-gap-line"></div>`);

        $wrapper.append($item);
      });

      if (targetelem) {
        Popups.openMenu("value-selector", targetelem);
      }
      else {
        Popups.to("value-selector", setBackPopup);
      }

    });

  }

  setMinWidth = (width: number) =>
  {
    this.$root.find(".content").css("min-width", width);
  }

  clearDropdownSetting = () =>
  {
    this.$root.find(".content").css("min-width", "");
  }
}